import EventEmitter from "events";
import React from "react";
import { TicketModel } from "../../mvcapi/models/buyticket/submodels";
import { Point } from "../models";

export class VenuePlanControl extends EventEmitter {
    
    onMoveToSeatsBySky(cb: () => void) { this.on("moveToSeatsBySky", cb); }
    offMoveToSeatsBySky(cb: () => void) { this.removeListener("moveToSeatsBySky", cb); }
    moveToSeatsBySky() { this.emit("moveToSeatsBySky"); }

    onMoveToSeats(cb: () => void) {this.on("moveToSeats", cb); }
    offMoveToSeats(cb: () => void) { this.removeListener("moveToSeats", cb); }
    moveToSeats() { this.emit("moveToSeats"); }

    onMoveToXYZoomAtLeast(cb: (center: {x: number, y: number}, zoom: number, time: number) => void) {this.on("moveToXYZoomAtLeast", cb); }
    offMoveToXYZoomAtLeast(cb: (center: {x: number, y: number}, zoom: number, time: number) => void) { this.removeListener("moveToXYZoomAtLeast", cb); }
    moveToXYZoomAtLeast(center: {x: number, y: number}, zoom: number, time: number) { this.emit("moveToXYZoomAtLeast", center, zoom, time ); }

    onMoveToOverview(cb: () => void) { this.on("moveToOverview", cb); }
    offMoveToOverview(cb: () => void) { this.removeListener("moveToOverview", cb); }
    moveToOverview() { this.emit("moveToOverview"); }

    onRefreshSeatsOnPlan(cb: () => void) { this.on("refreshSeatsOnPlan", cb); }
    offRefreshSeatsOnPlan(cb: () => void) { this.removeListener("refreshSeatsOnPlan", cb); }
    refreshSeatsOnPlan() { this.emit("refreshSeatsOnPlan"); }

    onShowPlanRequest(cb: (focusOn?: Point) => void) { this.on("showPlanRequest", cb); }
    offShowPlanRequest(cb: (focusOn?: Point) => void) { this.removeListener("showPlanRequest", cb); }
    showPlanRequest(focusOn?: Point) { this.emit("showPlanRequest", focusOn); }
}

export class VenuePlanControlContextClass { 
    remoteControl: VenuePlanControl;

    constructor() {
        this.remoteControl = new VenuePlanControl();
    }
}

export const VenuePlanControlContextInstance = new VenuePlanControlContextClass();

export const VenuePlanControlContext = React.createContext<VenuePlanControlContextClass>(VenuePlanControlContextInstance);


